import { useProductsContext } from "../../contexts";
import { Modal } from 'antd'
import commonObj from '../../../utils/Common';

const { confirm } = Modal;
const AddressCard = ({
  address,
  isEdit,
  showInput = true,
  editAddress,
  setEditAddress,
  setShowAddressForm,
  userType
}) => {
  const { id, fullName, mobile, address1, address2, pin, nearBy, pCity, pState, city, state, pCountry, isDefault } = address;
  const { currentAddress, setCurrentAddress, updateAddress, deleteAddress, setDefaultAddress } =
    useProductsContext();
    

    const handleDelete = (id) => { 
      confirm({
          title: commonObj.getLabel('Do_you_Really_wants_Delete_address'),
          async onOk() {
            deleteAddress(id)
          },
          onCancel() {
            console.log('Cancel');
          },
      });
  }
    //console.log(isDefault,'currentAddress')
    //if(isDefault) setCurrentAddress(address)
  return (
    <label
      className={`flex ${
        id === currentAddress.id && isEdit ? "bg-gray-100" : "bg-gray-50"
      }  items-center gap-2 shadow-sm p-4 rounded-sm cursor-pointer addresscard`}
    >
      {showInput && (
        <input
          type="radio"
          name="address"
          id={id}
          className="accent-current me-2"
          defaultChecked={isDefault==1}
          value="1"
          onChange={() => setDefaultAddress(id,address?.userId,address)}
        />
      )}
      <div title="set default address">
        <h3 className="text-lg font-semibold break-all">{fullName}</h3>
        {userType!=5 && (
        <p className="text-sm text-gray-500 break-all">
          {address1},{address2}, {commonObj.getLabel('nearby')} {nearBy}
        </p>
       )}
        <p className="text-sm text-gray-500 break-all">
          {city?.pcity_name},{pin}
        </p>
        
        <p className="text-sm text-gray-500 break-all">
          {state?.pstate_name},{pCountry}
        </p>
        <p className="text-sm text-gray-500">
          {commonObj.getLabel('Mobile')}:
          <span className="font-semibold ps-1 break-all">{mobile}</span>
        </p>
        {isEdit && (
          <div className="flex gap-3 py-2">
            <button
              className="text-amber-500 font-bold"
              onClick={() => {
                setEditAddress(address);
                setShowAddressForm(true);
              }}
            >
              {commonObj.getLabel('Edit')}
            </button>
            <button
              className="text-red-600 font-bold"
              onClick={() => handleDelete(id)}
            >
              {commonObj.getLabel('Remove')}
            </button>
          </div>
        )}
      </div>
    </label>
  );
};
export default AddressCard;
